exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "@keyframes fadeIn{0%{opacity:0}100%{opacity:1}}.errorMessage{color:red;font-size:smaller;animation:fadeIn 555ms linear}\n", ""]);

